import { BaseService, NOME_TOKEN_ACESSO_DIRETO } from '@thema/base-servicos'

const urlAtaRegistroPreco = '/service/materiais/ataRegistroPreco/'

class DetalhesAtaRegistroPrecoService extends BaseService {
    constructor() {
        const config = JSON.parse(sessionStorage.getItem('config'))
        super(NOME_TOKEN_ACESSO_DIRETO, config)
    }

    consultar(filtro) {
        let data = {
            sequencia: filtro.sequencia,
        }

        return this.conex.post(urlAtaRegistroPreco + 'detalhesAtaRegistroPreco/', JSON.stringify(data))
    }

    consultarDetalhesItensAta(filtro) {
        let data = {
            sequencia: filtro.sequencia,
        }
        return this.conex.post(urlAtaRegistroPreco + 'detalhesItensAta/', JSON.stringify(data))
    }

    consultarDetalhesFornecedoresItem(filtro) {
        let data = {
            sequencia: filtro.sequencia,
        }
        return this.conex.post(urlAtaRegistroPreco + 'detalhesFornecedoresItem/', JSON.stringify(data))
    }

    consultarDetalhesDestinoItem(filtro) {
        let data = {
            sequencia: filtro.sequencia,
        }
        return this.conex.post(urlAtaRegistroPreco + 'detalhesDestinoItem/', JSON.stringify(data))
    }

    consultarEmpenhosAta(filtro) {
        let data = {
            sequencia: filtro.sequencia,
        }
        return this.conex.post(urlAtaRegistroPreco + 'detalhesEmpenhosAta/', JSON.stringify(data))
    }

    consultarContratoAta(filtro) {
        let data = {
            sequencia: filtro.sequencia,
        }
        return this.conex.post(urlAtaRegistroPreco + 'contratoAta/', JSON.stringify(data))
    }
}

export default DetalhesAtaRegistroPrecoService
